var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 30,
    viewBox: "0 0 61 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.28 28.24L14.36 19.6H6.44L3.36 28.24H6.36V29H0.24V28.24H2.12L12.32 0.759999H15.6L25.68 28.24H27.52V29H14.44V28.24H17.28ZM10.56 8.24L6.8 18.72H14.04L10.56 8.24ZM49.7428 0.999998V1.88L37.9028 28.08H39.2628C41.6628 28.08 43.7695 27.32 45.5828 25.8C47.4228 24.2533 48.7428 22.0667 49.5428 19.24H50.2628L49.7828 29H29.3028V28.24L41.2628 1.88H39.6228C37.2495 1.88 35.4495 2.4 34.2228 3.44C32.9961 4.48 31.6095 6.61333 30.0628 9.84H29.3428L29.9428 0.999998H49.7428ZM57.115 29.4C55.9683 29.4 55.1017 29.0667 54.515 28.4C53.955 27.7067 53.675 26.88 53.675 25.92C53.675 24.9333 53.9683 24.1067 54.555 23.44C55.1683 22.7733 56.0217 22.44 57.115 22.44C58.2083 22.44 59.075 22.72 59.715 23.28C60.355 23.84 60.675 24.68 60.675 25.8C60.675 26.92 60.3683 27.8 59.755 28.44C59.1683 29.08 58.2883 29.4 57.115 29.4Z",
    fill: "#E1E1E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/LogoDark.49093f1caa6a4399e385e0f0d2577465.svg";
export { ForwardRef as ReactComponent };